import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";

const SITE_PATHS = ["/", "/our-group", "/founder", "/ventures", "/vision-values", "/gallery", "/blog", "/contact", "/privacy", "/terms"];

const AdminPages = () => {
  const [overrides, setOverrides] = useState({});
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => adminApi.get("/pages").then((res) => {
    const map = {};
    res.data.forEach((p) => { map[p.path] = p; });
    setOverrides(map);
  }).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const openPath = (path) => setActive({ path, seo_title: overrides[path]?.seo_title || "", seo_description: overrides[path]?.seo_description || "" });

  const save = async (e) => {
    e.preventDefault();
    const cleanPath = active.path.replace(/^\//, "");
    await adminApi.put(`/pages/${cleanPath}`, { seo_title: active.seo_title, seo_description: active.seo_description });
    setActive(null);
    load();
  };

  return (
    <AdminPageShell title="Pages" description="Override SEO title/description for any route on the public site." testId="admin-pages-page">
      {active && (
        <form onSubmit={save} className="neu-panel p-6 mb-8 space-y-4" data-testid="admin-page-form">
          <span className="eyebrow block">{active.path}</span>
          <input placeholder="SEO Title" value={active.seo_title} onChange={(e) => setActive({ ...active, seo_title: e.target.value })} className="neu-inset w-full h-11 px-3" data-testid="admin-page-seo-title-input" />
          <textarea placeholder="SEO Description" value={active.seo_description} onChange={(e) => setActive({ ...active, seo_description: e.target.value })} className="neu-inset w-full p-3" rows={2} data-testid="admin-page-seo-desc-input" />
          <div className="flex gap-3">
            <button type="submit" className="btn-solid-pearl" data-testid="admin-page-save-btn">Save</button>
            <button type="button" onClick={() => setActive(null)} className="btn-outline-silver">Cancel</button>
          </div>
        </form>
      )}
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-2">
          {SITE_PATHS.map((path) => (
            <button key={path} onClick={() => openPath(path)} className="neu-surface neu-surface-hover w-full text-left p-4 flex items-center justify-between" data-testid={`admin-page-row-${path.replace(/\//g, "-") || "home"}`}>
              <span className="text-body" style={{ color: "var(--gg-ivory)" }}>{path}</span>
              <span className="text-small">{overrides[path]?.seo_title || "No override"}</span>
            </button>
          ))}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminPages;
